import * as ProofOfWork from '../types/proofOfWork';
import { Result } from '../../result';

// TODO: place holder until the pow backend service ready.
const fakeGetPuzzleReturnResponse: ProofOfWork.GetPuzzleReturnType = {
  puzzleType: 'TIME_LOCK',
  artifact: 'TEST_ARTIFACT'
};

const fakeGetPuzzleReturnResult: Result<ProofOfWork.GetPuzzleReturnType, null> = {
  value: fakeGetPuzzleReturnResponse,
  isError: false
};

export const getPuzzle = async (
  sessionID: string
): Promise<Result<ProofOfWork.GetPuzzleReturnType, null>> => {
  return new Promise<Result<ProofOfWork.GetPuzzleReturnType, null>>(resolve => {
    setTimeout(() => {
      resolve(fakeGetPuzzleReturnResult);
    }, 3000);
  });
};

const fakeVerifyPuzzleReturnResponse: ProofOfWork.VerifyPuzzleReturnType = {
  answerCorrect: true,
  message: '',
  redemptionToken: 'redemptionToke'
};

const fakeVerifyPuzzleReturnResult: Result<ProofOfWork.VerifyPuzzleReturnType, null> = {
  value: fakeVerifyPuzzleReturnResponse,
  isError: false
};

export const verifyPuzzle = async (
  sessionID: string,
  solution: string
): Promise<Result<ProofOfWork.VerifyPuzzleReturnType, null>> => {
  return new Promise<Result<ProofOfWork.VerifyPuzzleReturnType, null>>(resolve => {
    setTimeout(() => {
      resolve(fakeVerifyPuzzleReturnResult);
    }, 3000);
  });
};
